import { $generateHtmlFromNodes } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { Button, CircularProgress } from '@mui/material'

interface TextEditorProps {
    onAccept: (data: string) => void,
    onCancel: VoidFunction,
    processing?: boolean,
    disabled?: boolean
}

export default function TextEditorOptions({ onAccept, onCancel, processing, disabled }: TextEditorProps) {
    const [editor] = useLexicalComposerContext()
    const handleClick = () => {
        editor.update(() => {
            const htmlString = $generateHtmlFromNodes(editor, null)
            onAccept(htmlString)
        })
    }
    return (
        <div className='texteditor-options'>
            <Button
                size='small'
                fullWidth
                disableElevation
                variant='contained'
                className='m-auto app-btn-color'
                onClick={handleClick}
                disabled={processing || disabled}
            >
                {processing ? <CircularProgress size={'1.5rem'} color='warning' /> : 'Publicar'}
            </Button>
            <Button
                size='small'
                fullWidth
                disableElevation
                variant='contained'
                color='inherit'
                className='m-auto'
                onClick={onCancel}
                disabled={processing}
            >
                Cancelar
            </Button>
        </div>
    )
}
